@if (loading | async) {
  <div class="loading-bar">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

@if (data?.showHeader) {
  <div class="header" appFitText data-cy="value-display-header">
    <span>{{ header }}</span>
  </div>
}

@if (data) {
  <div class="value-container">
    <div class="value" appFitText>
      @if (isDataValid && value !== null) {
        <span class="value">{{ valueString | formatValue: this.data.decimalPlaces }}</span>
        @if (data.showUnit && data.unit) {
          <span class="unit">{{ data.unit }}</span>
        }
      } @else {
        @if ((loading | async) === false) {
          <span class="no-data">{{ 'ERROR.NO_RECORDS' | translate }}</span>
        }
      }
    </div>
  </div>
}

@if (data?.showDate) {
  <div class="date" appFitText>
    @if (date && data.range) {
      <span>
        <app-date-display
          [value]="savedResponse?.start ?? data.range.min"
          [format]="'short'"
        ></app-date-display>
        -
        <app-date-display
          [value]="savedResponse?.end ?? data.range.max"
          [format]="'short'"
        ></app-date-display>
      </span>
    }
  </div>
}
